import {Divider} from '@mantine/core';
import {isReleasedRedesignRecruitment} from '../../../../../config/unReleasePage';
import {
  RECRUITMENT_DETAIL_RESOURCE_TYPE,
  RECRUITMENT_RESOURCE_CONTENT_TYPE,
} from '../../../../../core/entities/recruitment/constants';
import {convertToLink} from '../../../../../shared/services/convertToLink';
import type {RecruitmentDetailResourceWithParsedContent} from '../../../usecases/parseResourceContent';

export const ResourceContentItem: React.FC<{
  resource: RecruitmentDetailResourceWithParsedContent;
  isHydrated: boolean;
}> = ({resource, isHydrated}) => {
  if (
    !isHydrated ||
    resource.resourceType !== RECRUITMENT_DETAIL_RESOURCE_TYPE.CONTENT
  )
    return null;

  if (isReleasedRedesignRecruitment()) {
    return (
      <div
        key={`resource-content-${resource.resourceID}`}
        className="w-full bg-white p-16 rounded-16 mt-8"
      >
        <h2 className="font-bold">{resource.title}</h2>
        <Divider className="my-8" />
        {resource.contentType === RECRUITMENT_RESOURCE_CONTENT_TYPE.MARKDOWN &&
        resource.parsedContent ? (
          <div
            className="text-base text-black-1 leading px-8"
            data-resource-content={resource.resourceID}
            dangerouslySetInnerHTML={{__html: resource.parsedContent}}
          />
        ) : (
          <p className="text-base text-black-1 px-8">
            {convertToLink(resource.content)}
          </p>
        )}
      </div>
    );
  }

  return (
    <div key={`resource-content-${resource.resourceID}`} className="mt-8">
      <h2 className="text-md font-bold text-black-1 leading border-collapse border-l-8 border-l-primary-1 px-12 py-8 text-left my-12 break-all">
        {resource.title}
      </h2>
      {resource.contentType === RECRUITMENT_RESOURCE_CONTENT_TYPE.MARKDOWN &&
      resource.parsedContent ? (
        <div
          className="text-base text-black-1 leading px-8"
          data-resource-content={resource.resourceID}
          dangerouslySetInnerHTML={{__html: resource.parsedContent}}
        />
      ) : (
        <p className="text-base text-black-1 px-8">
          {convertToLink(resource.content)}
        </p>
      )}
    </div>
  );
};
